export class GetDataCatalogSemanticLayerScheduleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "interval",
            "baseName": "interval",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastRunTime",
            "baseName": "lastRunTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "nextRunTime",
            "baseName": "nextRunTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogSemanticLayerScheduleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
